import {post,get,postWithRetry,nPost} from '../../libs/ajax.js'

export default {

    /* 工单上传 & 素材库上传*/

    // 工单上传-批量上传
    batchMaterialUpload(data) {
        return post('/order_task/detail_material/batch_upload', data)
    },
    // 重新上传
    reMaterialUpload(data) {
        return post('/order_task/detail_material/re_upload', data)
    },
    // 工单上传-单个上传
    singleMaterialUpload(data) {
        return post('/order_task/detail_material/upload', data)
    },

    // 素材库上传
    uploadMaterialStorehouse(data) {
        return post('/material_storehouse/upload', data)
    },
    
    // 获取项目
    getProjectList:(data,options) => {
        return nPost('/work_order/get_project_list', data, options);
    },
    // 获取项目-素材库
    getStoreProjectList:(data,options) => {
        return get('/material_storehouse/get_project_list', data, options);
    },



    // 获取标签列表
    getLabelList:(data,options) => {
        return get('/work_order/label_list', data, options);
    },
    // 获取制作人列表
    getProducerList:(data,options) => {
        return get('/work_order/producer_list', data, options);
    },
    // 获取制作人列表-2024.10.30
    getProducerGroupList:(data,options) => {
        return get('/work_order/producer_group_list', data, options);
    },
    // 获取编导列表
    getDirectorList:(data,options) => {
        return get('/work_order/director_list', data, options);
    },
    // 素材列表-上传前验证
    preCheckFile(data,options) {
        return postWithRetry('/order_task/detail_material/upload_precheck', data,options)
    },
    // 素材列表-上传前验证
    preCheckStoreFile(data,options) {
        return postWithRetry('/material_storehouse/upload_precheck', data,options)
    },
    // 上传弹框-文件名批量归类出「素材分类标签」默认值（workOrder_v5 §1 二次拍板）。data:{names:[...]} → [{name,label,lv1..lv4}]
    // 任务管理上传走 order_task（挂 upload_material 3887），素材库上传走 material_storehouse（挂 3895），与 precheck 同一套挂法
    classifyFileNames(data,options) {
        return post('/order_task/detail_material/name_classify', data,options)
    },
    classifyStoreFileNames(data,options) {
        return post('/material_storehouse/name_classify', data,options)
    },

    // 任务管理 - 获取详情任务列表
    getWorkTaskDetailList:(data,options) => {
        return get('/order_task/get_detail_list', data, options);
    },

    // 编辑素材-素材库
    editStoreMaterial(data) {
        return post('/material_storehouse/edit', data)
    },
    // 编辑素材-工单
    editOrderMaterial(data) {
        return post('/order_task/detail_material/edit', data)
    },
    // 工单上传-点击上传按钮验证是否可以上传
    checkBeforeUpload(data) {
        return post('/order_task/detail_material/upload_check', data)
    },
    // 获取素材的格式
    getMaterialFormat:(data,options) => {
        return get('/work_order/tag_config/get_material_format', data, options);
    },
    // 工单加锁
    lockWorkOrder:(data,options) => {
        return post('/work_order/lock', data, options);
    },
    // 工单解锁
    unLockWorkOrder:(data,options) => {
        return post('/work_order/unlock', data, options);
    },
    getWorkOrderLock:(data,options) => {
        return post('/work_order/get_lock', data, options);
    },
}
